import { render, staticRenderFns } from "./ModalEditEventProgram.vue?vue&type=template&id=046fb912&scoped=true"
import script from "./ModalEditEventProgram.vue?vue&type=script&lang=js"
export * from "./ModalEditEventProgram.vue?vue&type=script&lang=js"
import style0 from "./ModalEditEventProgram.vue?vue&type=style&index=0&id=046fb912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046fb912",
  null
  
)

export default component.exports